var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBike1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 42,
    viewBox: "0 0 367 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 36.8096H367V41.2858H320V36.8096Z",
    fill: "#FBA819"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.048 4.47619C360.048 2.01428 358.033 0 355.571 0H348.857V4.47619H355.571V10.4071L347.783 20.1428H339.905V8.95237H330.952C326.006 8.95237 322 12.9586 322 17.9047V24.619H326.476C326.476 28.3343 329.475 31.3333 333.19 31.3333C336.906 31.3333 339.905 28.3343 339.905 24.619H349.931L360.048 11.9738V4.47619ZM326.476 20.1428V17.9047C326.476 15.4428 328.49 13.4286 330.952 13.4286H335.429V20.1428H326.476ZM333.19 26.8571C331.96 26.8571 330.952 25.85 330.952 24.619H335.429C335.429 25.85 334.421 26.8571 333.19 26.8571Z",
    fill: "#3E3E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M328.714 2.23804H339.904V6.71422H328.714V2.23804ZM360.047 17.9047C356.332 17.9047 353.333 20.9037 353.333 24.619C353.333 28.3342 356.332 31.3333 360.047 31.3333C363.762 31.3333 366.761 28.3342 366.761 24.619C366.761 20.9037 363.762 17.9047 360.047 17.9047ZM360.047 26.8571C358.816 26.8571 357.809 25.8499 357.809 24.619C357.809 23.388 358.816 22.3809 360.047 22.3809C361.278 22.3809 362.285 23.388 362.285 24.619C362.285 25.8499 361.278 26.8571 360.047 26.8571Z",
    fill: "#3E3E3E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: 37.2856,
    width: 13,
    height: 4,
    fill: "#FBA819"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 207,
    y: 37.2856,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115,
    y: 37.2856,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 37.2856,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 37.2856,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 37.2856,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 37.2856,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 37.2856,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 37.2856,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 37.2856,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.7
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 37.2856,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 37.2856,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 37,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    y: 37,
    width: 13,
    height: 4,
    fill: "#FBA819",
    fillOpacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike1);
export default __webpack_public_path__ + "static/media/Bike 1.c69e45225a10551230e56bc238a4946b.svg";
export { ForwardRef as ReactComponent };